<template>
  <v-app :lang="lang.langname"  id="inspire">

    <MobilePortalShell v-if="$route.meta.portal">
      <router-view />
    </MobilePortalShell>

    <template v-else>
      <v-main :style="`direction:`+lang.dir ">
        <router-view />
      </v-main>

      <FloatButton v-show="!withsidemenu" />
      <License />
    </template>
  </v-app>
</template>

<script>
import Vue from 'vue';
import FloatButton from "./components/FloatButton.vue";
import License from "./components/License.vue"
import MobilePortalShell from "./components/MobilePortalShell.vue"
// import Header from '@/components/Header.vue'
import axios from 'axios'

export default Vue.extend({
  name: 'App',
  components: {FloatButton,License,MobilePortalShell},
  data: () => ({
    drow:false,
    connected:false,
    withsidemenu:true,
  }),

  computed: {
      lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
  },

  methods:{
    getStart(){
      let pp = new FormData();
      pp.append('defBranch',localStorage.getItem('defBranch') || '');
      pp.append('financeYear',localStorage.getItem('financeYear') || '');
      let type = 'getMeTodo';
      pp.append('type',type);
      axios.post(
          this.$store.state.SAMCOTEC.r_path
          ,pp
      ).then((response) => {
          this.$store.commit('setLicenseType',response.data.results.data);
          this.$store.state.redirectURl = response.data.results.loginRedirect;
          localStorage.setItem('_ECar_',JSON.stringify(response.data.results.data));
          localStorage.setItem('redirectURl',JSON.stringify(response.data.results.redirectURl));

      })

    },
    handleUpdate: function () {
      //this.connected = true;
    },
    getCookies(){
      if(this.connected == true) return false;
      let x = this.$cookies.get(this.$store.state.COOKIEPhase);
      if(x == null){

        this.connected = false;
        if(this.$route.name != 'Login')
          this.$router.push({name: "Login"})
      }
      else{
        this.connected = true;
        if(this.$route.name == 'Login')
          this.$router.push({name: 'Home'});
      }
    },
    checkLicense(){
      axios.get(
        this.$store.state.SAMCOTEC.r_path
      ).then( (response) => {

        const res = response.data;
        if(res.error.number == 555){
          // document.getElementById('apply_license').style.display = "block";
          // this.license = res.results.data[1];
          // this.settings = res.results.data[0];
        }
      })
    },

  },
  created() {
    if(!this.$route.meta.portal){
      setTimeout(() => {this.getStart();},1000);
    }
    document.title = this.$store.state.SystemName;
    //this.getCookies()
  },
});
</script>
<style>
.v-text-field{
  padding-top:0px !important;
  margin-top:0px !important;
  font-size:.5em !important;
  background:#f0fbff !important;
}
.v-data-table>.v-data-table__wrapper>table>tbody>tr>td, .v-data-table>.v-data-table__wrapper>table>tfoot>tr>td, .v-data-table>.v-data-table__wrapper>table>thead>tr>td {
    font-size: .875rem;
    height: 10px !important;
}
.v-data-table-header__icon{
  display:none !important;
}
.outsearch{
  color:green;
  border:1px solid #ccc;
}
thead th{
  background: #7aa5da !important;
  color:#000 !important;
  border:1px solid #eee !important;
  font-size:12px;
  white-space: nowrap;
}
thead th a , thead th i, thead th i a{
  color:#FFF !important;
  white-space: nowrap;
}
tbody td{
  font-size:12px;
  color:#000 !important;
  white-space: nowrap;
  border:1px solid #ccc;
}
.v-breadcrumbs{
  padding:12px !important;
}
.v-tab--active{
  background:#ccc;
  color:#FFF;
}
.v-tabs-slider-wrapper a{
  color:#FFF !important;
}
tfoot th{
  border:1px solid #ccc;
}
.close svg {
    width: 24px !important;
    height: 24px !important;
    color: #FFF;
    background: red;
    border-radius: 50%;
}
header button.close {
    width: 24px !important;
    height: 24px !important;
}
.snotify-centerCenter{
  width:700px;
  left: calc(50% - 700px/ 2);
}
</style>